import React, { useState, useEffect } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import "./Merchandise.css";

function Merchandise() {
    const [merchItems, setMerchItems] = useState([]);
    const [expandedCardIndex, setExpandedCardIndex] = useState(null);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        async function fetchMerchItems() {
            try {
                const response = await axiosInstance.get('/merchandise/all');
                const visibleItems = response.data.filter(item => item.visibleToCustomer);
                setMerchItems(visibleItems);
            } catch (error) {
                console.error('Error fetching merchandise items:', error);
            }
        }
        fetchMerchItems();
    }, []);

    const handleCardClick = (index, event) => {
        event.stopPropagation(); // Prevent event bubbling
        event.preventDefault(); // Prevent any default behavior
        
        // Prevent clicking during transition
        if (isTransitioning) {
            return;
        }
        
        console.log('Card clicked at index:', index, 'Current expanded index:', expandedCardIndex);
        
        // Set transitioning state to prevent rapid clicks
        setIsTransitioning(true);
        
        // If clicking the same card, close it. Otherwise, open the clicked card and close others
        if (expandedCardIndex === index) {
            console.log('Closing card at index:', index);
            setExpandedCardIndex(null);
        } else {
            console.log('Opening card at index:', index);
            setExpandedCardIndex(index);
        }
        
        // Allow new clicks after transition completes (0.3s)
        setTimeout(() => {
            setIsTransitioning(false);
        }, 300);
    };

    // Individual card component to ensure isolation
    const MerchCard = ({ item, index, isExpanded, onCardClick, isTransitioning }) => {
        const cardId = `merch-card-${index}`;
        const detailsRef = React.useRef(null);
        
        console.log(`Card ${cardId}: isExpanded = ${isExpanded}`);
        
        return (
            <div 
                className="merch-card-wrapper"
                onClick={(e) => onCardClick(index, e)}
            >
                <div 
                    key={cardId}
                    id={cardId}
                    className={`merch-card ${isExpanded ? 'expanded' : ''} ${isTransitioning ? 'transitioning' : ''}`}
                    data-index={index}
                    data-sku={item.sku}
                    style={{ isolation: 'isolate' }} // Force stacking context
                >
                    <div className="merch-image-container">
                        <img 
                            src={item.imageUrl || "/placeholder-image-300x300.png"} 
                            alt={item.name} 
                            className="merch-image"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/placeholder-image-300x300.png";
                            }}
                        />
                        <div className="merch-overlay">
                            <h3 className="merch-item-title">{item.name}</h3>
                            <p className="merch-description">{item.description}</p>
                        </div>
                        <div className="merch-price-badge">
                            <span className="merch-price">${item.price.toFixed(2)}</span>
                        </div>
                        <div className="in-store-badge">
                            <span>In-Store Only</span>
                        </div>
                    </div>
                    <div className="merch-details" ref={detailsRef}>
                        <p><span className="detail-label">Size:</span> {item.sizes.join(", ")}</p>
                        <p><span className="detail-label">Color:</span> {item.color}</p>
                        <p className="in-store-notice">
                            <span className="detail-label">Availability:</span> 
                            <span className="in-store-text"> In-Store Purchase Only</span>
                        </p>
                    </div>
                    {/* Click to expand indicator - positioned at bottom of card */}
                    {!isExpanded && (
                        <div className="click-to-expand-indicator">
                            <span>Click to expand</span>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="merchandise-container">
                <h1>Merch & Apparel</h1>
                <div className="merch-grid">
                    {merchItems.map((item, index) => {
                        const isExpanded = expandedCardIndex === index;
                        return (
                            <MerchCard
                                key={`merch-card-${index}`}
                                item={item}
                                index={index}
                                isExpanded={isExpanded}
                                onCardClick={handleCardClick}
                                isTransitioning={isTransitioning}
                            />
                        );
                    })}
                </div>
            </div>
            <div style={{ 
                aspectRatio: "960/100", 
                backgroundImage: "url('/blueToPinkFooter.png')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center"
            }}></div>
        </>
    );
}

export default Merchandise;
